module.exports = __webpack_public_path__ + "media/react/components/UI/Background/Background-3c1061951203d82ae876b8ec6839c9cf.png";